"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _CacheKeys = _interopRequireDefault(require("reference-resolvers/constants/CacheKeys"));

var _TicketPipelinesAPI = require("reference-resolvers/api/TicketPipelinesAPI");

var _createSimpleCachedReferenceResolver = _interopRequireDefault(require("reference-resolvers/lib/createSimpleCachedReferenceResolver"));

var _get = _interopRequireDefault(require("transmute/get"));

var _default = (0, _createSimpleCachedReferenceResolver.default)({
  cacheKey: _CacheKeys.default.TICKET_PIPELINES,
  fetchData: _TicketPipelinesAPI.getAllTicketPipelines,
  selectReferences: (0, _get.default)('pipelines')
});

exports.default = _default;
module.exports = exports.default;